<template>
  <v-card>
    <v-card-title>
      <div class="flex-grow-1">HCCs</div>
      <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table :loading="loading" :headers="headers" :items="patient_data" :search="search">
      <template v-slot:no-data> No HCCs </template>
    </v-data-table>
  </v-card>
</template>

<script>
import axios from 'axios';

export default {
  name: 'HCC',
  props: ['patient', 'insurance'],

  data() {
    return {
      search: '',
      loading: false,
      headers: [
        { text: 'Patient', value: 'MEMBER_NAME' },
        { text: 'Provider', value: 'PCP_NAME' },
        { text: 'Servicer', value: 'SERVICE_LOCATION_NAME' },
        { text: 'Date', value: 'CLAIM_DATE' },
        { text: 'Code', value: 'CODE' },
        { text: 'HCC Category', value: 'HCC_CATEGORY' },
        { text: 'HCC Description', value: 'HCC_DESCIRPTION' },
      ],
      patient_data: [],
    };
  },
  mounted() {
    this.getClaims();
  },
  methods: {
    async getClaims() {
      this.loading = true;

      await axios.get(`/api/patient/hcc/${this.insurance}/${this.patient}/`).then((response) => {
        this.patient_data = response.data;
        this.loading = false;
      });
    },
  },
};
</script>
